function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import App, { IntlHelmet, LanguageProvider, LanguageSelector, OfflineOverlay } from 'modules/App';
import messages from '../../messages';
import SupportLink from '../../partials/SupportLink';
import styles from './LogoMobileLayout.pcss';
var _React_Component;
class LogoMobileLayout extends (_React_Component = React.Component) {
    onKeyDown(evt) {
        // If ESC
        if (evt.keyCode === 27) {
            this.props.onCloseDropdown();
        }
    }
    renderChildren() {
        if (!this.props.isClientInitialized && !this.props.isNoInit) return null;
        return this.props.children;
    }
    renderPageHeader() {
        return /*#__PURE__*/ _jsxs("div", {
            className: cn(styles.pageHeader),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "/assets/img/contour-diabates-app.png",
                        className: styles.logoBar__logo,
                        alt: "Contour Diabetes Care"
                    })
                }),
                /*#__PURE__*/ _jsx(LanguageSelector, {})
            ]
        });
    }
    renderPageContent() {
        return /*#__PURE__*/ _jsx("div", {
            className: styles.container,
            children: /*#__PURE__*/ _jsx("div", {
                className: styles.containerInner,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "content",
                    children: [
                        this.renderChildren(),
                        /*#__PURE__*/ _jsx(SupportLink, {})
                    ]
                })
            })
        });
    }
    render() {
        const titleMessage = this.props.metaTitleMessage ? this.props.metaTitleMessage : _object_spread({}, messages.meta.title);
        const descriptionMessage = this.props.metaDescriptionMessage ? this.props.metaDescriptionMessage : _object_spread({}, messages.meta.description);
        return /*#__PURE__*/ _jsx(LanguageProvider, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: cn(styles.root, 'no-gutters'),
                onClick: this.props.onCloseDropdown,
                onKeyDown: (evt)=>this.onKeyDown(evt),
                children: [
                    /*#__PURE__*/ _jsx(IntlHelmet, {
                        titleMessage: titleMessage,
                        descriptionMessage: descriptionMessage
                    }),
                    this.renderPageHeader(),
                    this.renderPageContent(),
                    /*#__PURE__*/ _jsx(OfflineOverlay, {})
                ]
            })
        });
    }
}
_define_property(LogoMobileLayout, "propTypes", {
    // Explicit props
    metaTitleMessage: PropTypes.object,
    metaDescriptionMessage: PropTypes.object,
    // isAuthenticated       : PropTypes.bool,
    isNoInit: PropTypes.bool,
    // Implicit props
    children: PropTypes.node,
    isClientInitialized: PropTypes.bool,
    // Implicit actions
    onCloseDropdown: PropTypes.func
});
_define_property(LogoMobileLayout, "defaultProps", {
    // isAuthenticated: false,
    isNoInit: false
});
const mapStateToProps = (state)=>({
        isClientInitialized: App.selectors.isClientInitialized(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onCloseDropdown: ()=>dispatch(App.actions.closeDropdown())
    });
const ConnectedLogoMobileLayout = connect(mapStateToProps, mapDispatchToProps)(LogoMobileLayout);
export default withStyles(styles)(ConnectedLogoMobileLayout);
